import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, Col, Input, Row, Alert } from 'reactstrap';
import SaveLoader from "../loader/SaveLoader";
import validator from "validator";
import { LangValidation } from "../../lang/en/validation";
import axios from "axios";
import axiosRetry from 'axios-retry';
import { API_URL } from "../../config/Config";
// import { NavLink } from "react-router-dom";
import { setUser } from "./../../redux/actions/user";

import { Link } from 'react-router-dom'

// import { on } from 'cluster';
// import {generator} from 'generate-password';
const generator = require('generate-password');

axiosRetry(axios, { retries: 3 });


class LoginModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            modal2: false,
            activeItemPills: '1',
            fields: {
                email: '',
                password: '',
            },
            errors: {},
            hasAlert: false,
            hasAlert2: false,
            loading: true,
            apiError: "Your Email or Password is wrong"
        };

        this.toggle = this.toggle.bind(this);
        this.toggle2 = this.toggle2.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }
    toggle2() {
        this.setState({
            modal2: !this.state.modal2
        });
    }
    switchModal() {
        this.setState({
            modal: false,
            modal2: true
        });
    }
    render() {
        const { password, email } = this.state.fields;
        const { errors } = this.state;

        return (
            <div className="loginmodal-div">
                <Button color="info" block active={true} className="book-btn sign-in-modal" onClick={this.toggle}>Sign in</Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>For booking please login to the website</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="12">
                                {this.state.hasAlert ? <Alert color="danger">{this.state.apiError}</Alert> : ""}
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" sm="12">
                                <form className='validate-form' onSubmit={this.handleLogin.bind(this)} autoComplete='on'>
                                    <div className="md-form2 input-group2">
                                        <label>email</label>
                                        <Input type="email"
                                            label="Email"
                                            icon="envelope"
                                            className={errors["email"] ? "form-control is-invalid" : "form-control"}
                                            autoComplete="off"
                                            name="email"
                                            value={email}
                                            onChange={this.handleChange.bind(this)} />
                                        {errors["email"] ? <div className="invalid-feedback" >{errors["email"]}</div> : ""}
                                    </div>
                                    <br />
                                    <div className="md-form2 input-group2">
                                        <label>password</label>
                                        <Input type="password"
                                            label="Password"
                                            icon="key"
                                            className={errors["password"] ? "form-control is-invalid" : "form-control"}
                                            autoComplete="off"
                                            name="password"
                                            value={password}
                                            onChange={this.handleChange.bind(this)} />
                                        {errors["password"] ? <div className="invalid-feedback" >{errors["password"]}</div> : ""}

                                    </div>

                                    <div className="text-center mt3">
                                        <Button size="lg" type='submit' className="mt-4 btn-green w-50">
                                            <i className="la la-sign-in ml-1" />Sign in
                                        </Button>
                                    </div>
                                    {/* <div className="text-center">
                                        <NavLink to="/register" className="btn btn-link mb-4 mt-4">
                                            register in iranroute please click here
                                        </NavLink>
                                    </div> */}
                                    <div className="text-center">
                                        {/* <p className="text-center">
                                            you can continue with out login, but some functionality become limited for you so we recommend you to register and login in website
                                        </p> */}
                                        {/* <Button size="lg" className="mb-4 mt-4 btn-navy" onClick={this.switchModal.bind(this)}>
                                            continue with out login
                                        </Button> */}
                                    </div>
                                </form>
                                <div className="text-center mt3">
                                    <Button size="lg" className="mt-4 btn-signup w-50">
                                        <Link to='/register'>
                                            Sign Up
                                        </Link>
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modal2} toggle={this.toggle2} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Continue without register</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="12">
                                {this.state.hasAlert ? <Alert color="danger">{this.state.apiError}</Alert> : ""}
                            </Col>
                        </Row>
                        <form className='validate-form'>
                            <Row>

                                <Col md="12" sm="12">
                                    <div className="md-form2 input-group2">
                                        <label>email</label>
                                        <Input type="email"
                                            label="Email"
                                            icon="envelope"
                                            className={errors["email"] ? "form-control is-invalid" : "form-control"}
                                            autoComplete="off"
                                            name="email"
                                            value={email}
                                            onChange={this.handleChange.bind(this)} />
                                        {errors["email"] ? <div className="invalid-feedback" >{errors["email"]}</div> : ""}

                                    </div>
                                    <br />
                                    {/*             <div className="md-form2 input-group2">
                                        <label>password</label>
                                        <Input type="password"
                                               label="Password"
                                               icon="key"
                                               className={errors["password"]?"form-control is-invalid":"form-control"}
                                               autoComplete="off"
                                               name="password"
                                               value={password}
                                               onChange={this.handleChange.bind(this)}/>
                                        {errors["password"]?<div className="invalid-feedback" >{errors["password"]}</div>:""}

                                    </div>*/}

                                    <div className="text-center mt3">
                                        <Button size="lg" onClick={this.handleRegister.bind(this)} className="mt-4 btn-green w-50">Continue</Button>
                                    </div>


                                </Col>
                            </Row>
                        </form>
                    </ModalBody>
                </Modal>
                {!this.state.loading ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight} /> : ""}
            </div>
        );
    }
    handleValidation(callback) {
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.email)) {
            formIsValid = false;
            errors["email"] = LangValidation.required;
        } else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            errors["email"] = LangValidation.email;
        }

        if (validator.isEmpty(fields.password)) {
            formIsValid = false;
            errors["password"] = LangValidation.required;
        } else if (!validator.isLength(fields.password, { min: 6, max: undefined })) {
            formIsValid = false;
            errors["password"] = LangValidation.min;
        }

        this.setState({ errors }, () => {
            return callback(formIsValid)
        });

    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'password':
                if (validator.isEmpty(fields.password)) {
                    errors["password"] = LangValidation.required;
                } else if (!validator.isLength(fields.password, { min: 6, max: undefined })) {
                    errors["password"] = LangValidation.min;
                }
                break;
            case 'email':
                if (validator.isEmpty(fields.email)) {
                    errors["email"] = LangValidation.required;
                } else if (!validator.isEmail(fields.email)) {
                    errors["email"] = LangValidation.email;
                }
                break;
            default:

        }
        this.setState({
            fields, errors
        });

    }

    async handleRequest() {
        const formData = new FormData();
        const { password, email } = this.state.fields;
        formData.append('password', password);
        formData.append('email', email);
        this.setState({ loading: false });
        try {
            let response = await axios.post(`${API_URL}login`, formData);
            // console.log(response.status);
            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                if (error.response === undefined) {
                    console.log(error);
                } else {
                    let data = await error.response.data;
                    let apiErrorText = await data.data;
                    this.setState({ apiErrorText });
                }
                this.setState({ hasAlert: true });
            } else {
                let user = response.data.data;
                console.log(user);
                this.props.setUser(user);
                // this.props.history.push('/users');
                // this.context.router.history.push("/users");
                window.location.reload();
                this.setState({ modal: false });

            }
        } catch (e) {
            let apiError = await e.response;

            if (apiError === undefined) {
                console.log(e);
            } else {
                // let statusText = await apiError.statusText;
                // let status = await apiError.status;
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({ apiErrorText });
            }
            this.setState({ hasAlert: true });

        }
        console.log("done");
        this.setState({ loading: true });
    };

    async handleRegister() {
        const { email } = this.state.fields;
        let errors = {};

        if (!validator.isEmail(email)) {
            errors["email"] = LangValidation.email;
        } else {

            let firstname = "No Name";
            let lastname = "No Name";
            let password = generator.generate({
                length: 8,
                numbers: true
            });
            let cell_phone = "00100";
            const formData = { firstname, lastname, email, password, cell_phone, country_id: 1 };

            this.setState({ loading: false });
            console.log(formData);

            try {
                let response = await axios.post(`${API_URL}register`, formData, {
                    baseURL: 'http://tickets.mehdisaedi.com',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                });

                console.log(response);
                console.log("response");

                let user = await response.data.data;
                this.props.setUser(user);
                // this.props.history.push('/passengers-add');

            } catch (e) {
                // let apiError = await e.response;
                console.log(e);

                this.setState({ hasAlert: true });
            }
            this.setState({ loading: true });
        }
    };

    handleLogin(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser: user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);



// WEBPACK FOOTER //
// ./src/components/user/LoginModal.js